import { cn, SimpleContainer } from "@suraasa/placebo-ui"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{
  className?: string
  /**
   * Removes the max width and side padding so content spans the full
   * width of the parent.
   */
  fullWidth?: boolean
}>

/**
 * Page-level layout container. Caps content at 1440px and keeps a
 * responsive side gutter: 16px on phones, 40px from `sm`, 64px from `lg`.
 */
const PageContainer = ({ className, fullWidth = false, children }: Props) => {
  if (fullWidth) {
    return (
      <div className={cn("w-full max-w-none px-0", className)}>{children}</div>
    )
  }

  return (
    <SimpleContainer
      className={cn("w-full max-w-[1440px] sm:px-5 lg:px-8", className)}
    >
      {children}
    </SimpleContainer>
  )
}

export default PageContainer
